import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      width: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: theme.spacingInlineOnepulse,
    },
  }
})

export const TitleExpiration = styled(Text, theme => {
  return {
    base: {
      textAlign: 'center',
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextNeutralAlternative,
    },
  }
})

export const TitleCountdown = styled(Text, theme => {
  return {
    base: {
      textAlign: 'center',
      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextSuccessAlternative,
    },
  }
})
